define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetType = void 0;
    class FAssetType extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AssetGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetGroupError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SapCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SapCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsArchived", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsArchivedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrderSeq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrderSeqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAssetType.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AssetGroup = b.AssetGroup;
            a.AssetDesc = b.AssetDesc;
            a.SapCode = b.SapCode;
            a.IsArchived = (0, EntityUtil_1.toInt)(entity.IsArchived);
            a.OrderSeq = (0, EntityUtil_1.toInt)(entity.OrderSeq);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAssetType.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "AssetGroup", "Asset Group");
                this.validateReqNumber(validationState, "IsArchived", "Is Archived?");
                this.validateReqNumber(validationState, "OrderSeq", "Order Sequence");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AssetGroup: this.AssetGroup,
                AssetDesc: this.AssetDesc,
                SapCode: this.SapCode,
                IsArchived: this.IsArchived,
                OrderSeq: this.OrderSeq,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get AssetTypeDesc() {
            return this.AssetGroup + (this.AssetDesc && this.AssetDesc.trim().length > 0 ? ` (${this.AssetDesc})` : "") + (this.IsArchived == 1 ? " (Legacy)" : "");
        }
    }
    exports.FAssetType = FAssetType;
    Object.defineProperty(FAssetType, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAssetType"
    });
    Object.defineProperty(FAssetType, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset Type"
    });
    Object.defineProperty(FAssetType, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AssetGroup", "AssetDesc", "SapCode", "IsArchived", "OrderSeq"]
    });
    Object.defineProperty(FAssetType, "AssetGroupLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetType, "AssetGroupReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetType, "AssetDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetType, "AssetDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAssetType, "SapCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FAssetType, "SapCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAssetType, "IsArchivedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetType, "OrderSeqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "AssetGroup", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "AssetGroupError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "AssetDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "AssetDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "SapCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "SapCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "IsArchived", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "IsArchivedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "OrderSeq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetType.prototype, "OrderSeqError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetType.prototype, "merge", null);
});
